<template>
 <div class="goodsDetail" >
	 <div class="topHeader  clearfix" id="topHeader" >
		 <div class="headerLeft"  @click="fanhui">
			 <img src="../../assets/img/icon/detailBack.png" alt="">
		 </div>
		 <div class="headerRight" @click="tgCollect()" >
		 		 <img v-if="this.collectState == false" src="../../assets/img/icon/Collection.png" alt="">
				 <img v-else src="../../assets/img/icon/Collected.png" alt="">	 
		 </div>
	 </div>
	 <van-tabs v-model="active" scrollspy sticky>
	   <van-tab title="商品">
		 <div class="goodsInfo" >
		   <div class="swipeBox"  >
			<van-swipe @change="onChange">
			   <van-swipe-item v-for="(image, index) in images" :key="index" >
			        <img  :src="image? image : $store.state.defaultImg"  @click="Preview_img(images,index)"/>
			    </van-swipe-item>
			  <template #indicator>
			    <div class="custom-indicator">
			      {{ current + 1 }}/{{imagesCount}}
			    </div>
			  </template>
			</van-swipe>
		   </div>
		   <div class="goodsintr" >
			   <h4> <span>¥</span>{{goodsInfoData.price}}</h4>
			   <p>{{goodsInfoData.goods_name}}</p>
			   <div class="intrNum" >
				   <div class="freight" >
					   <img src="../../assets/img/icon/freight.png" alt="">
					   <span>运费{{goodsInfoData.freight}}</span>
				   </div>
				   <div class="SalesVolume" >
						<img src="../../assets/img/icon/SalesVolume.png" alt="">
						<span>销量 {{goodsInfoData.buy_count}}</span>
				   </div>
				   <div class="BrowseVolume" >
				   		<img src="../../assets/img/icon/BrowseVolume.png" alt="">
				   		<span>浏览量 {{goodsInfoData.view_count}}</span>
				   </div>
			   </div>
		   </div>
		    <div class="sku-container">
				   <van-action-sheet v-model="showBase"  close-icon>
						<div class="skuBox" >
							<div class="skuTop" >
								<div class="imgBox" >
                                   <img :src="skuData[3]" alt="">
								</div>
								<div class="skuTopText" >
                                   <h4><span>¥ </span>{{skuData[1]}}</h4>
								   <p>库存:{{skuData[2]}}</p>
								</div>
							</div>
							<!-- <div class="brand" v-if="skuSKey != null"  v-for=" (item,i) in skuData.keys" >
								<h4  >{{item}}</h4>
								<div class="brandList"  v-for=" (obj,index) in skuSpeces" :key='obj.index'>
									<span :class=" clickSVal == val.specValue ? 'active' : '' " v-if="item == index" v-for="val in obj" :key='val.specValue'  @click="chooseSku(val.specValue)" >{{val.specValue}}</span>
								</div>
							</div> -->
							<div v-if="skuSKey != null">
								<div class="brand">
									<div v-for="(item1,index1) in skuSKey" :key="index1" >
										<div  v-for=" (item,i) in specesObj" :key="i" class="brandList" >
											<div v-if="item1 == i" >
											<h4  :key="index">{{i}} </h4>	
											<span :class="obj.show ? 'active'  : '' "  v-for="obj in item" :key="obj.specValue" @click="chooseSku(item,obj)" >{{obj.specValue}}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- <div class="dayLuckDraw">
								<h4>颜色</h4>
								<div class="LuckDraw">
									<span class="active">黑色</span>
									<span >白色</span>
								</div>
								
								
							</div> -->
							<div class="stepNum" >
								<h4>数量</h4>
								<van-stepper v-model="buynum" :max="skuData[2]"  @change="ChangeNum" />
							</div>
							<div class="filterBtn" >
								<button class="joinCart" @click="addCart()" >加入购物车</button>
								<button class="nowBuy" @click="onClickBuy()" >立即购买</button>
							</div>
						</div>
					</van-action-sheet>
				   <div class="chooseSku clearfix" @click="showBase = true">
				   	<span>请选择规格</span>
				   	<img src="../../assets/img/icon/Specifications.png" alt="">
				   </div>
		    </div>
			 <div class="shopInfo" >
				 <div class="listBox">
				 	<div class="listInfo">
				 		<div class="infoTop clearfix">
				 			<div class="leftImg ">
				 				<img  :src="shopInfo.shop_logo? shopInfo.shop_logo : $store.state.defaultdp" >
				 			</div>
				 			<div class="rightText">
				 				<h5>{{shopInfo.shop_name}}
									  <img v-if="shopInfo.has_luck_draw == 1" src="../../assets/img/icon/dayLottery.png" alt="抽奖">
								 </h5>
				 				<p class="address">{{shopInfo.shop_local}}</p>
				 				<div class="shopScore">
				 					<div class="scoreKind">
				 					    <img src="../../assets/img/icon/describe.png">
				 						<span>宝贝描述</span>
				 						<p>{{shopInfo.shop_description_credit}}</p>
				 					</div>
				 					<div class="scoreKind">
				 						<img src="../../assets/img/icon/attitude.png">
				 						<span>服务态度</span>
				 						<p>{{shopInfo.shop_service_credit}}</p>
				 					</div>
				 					<div class="scoreKind">
				 						<img src="../../assets/img/icon/speed.png">
				 						<span>发货速度</span>
				 						<p>{{shopInfo.shop_delivery_credit}}</p>
				 					</div>
				 				</div>
				 			</div>
				 		</div>
				 		<div class="shopBtn">
				 			<van-button class="goodsBtn"  @click='allGoods()'  color="#FF5507" plain>全部商品</van-button>
				 			<van-button class="goshopBtn" @click='goshop()' color="linear-gradient(to right, #FE8702, #FF1000)">进入店铺</van-button>
				 		</div>
				 	</div>
			 </div>
			</div>
		 </div> 
	   </van-tab>
	   <van-tab title="评价">
		   <div class="evaluateBox" >
			  <div class="evaluateTitle clearfix" >
			  	 <span class="titleText" >评价</span>
			  		 <div class="moreEvaluate"  @click="goMoreEvaluate()" >
			  			<span>更多</span> 
			  			<img src="../../assets/img/icon/moreEvaluate.png" alt="">
					</div>
			  </div> 
			  <div class="evaluateContent" v-if="this.commentLength != 0">
				  <div class="eContentList" v-for="(obj,i) in goodsInfoData.comment_list" :key="i" >
					  <div class="eListTop" >
						  <img :src="obj.member_face" alt="">
						  <span>{{obj.member_name}}</span>
					  </div>
					  <div class="eListBottom" >
						  <p>{{obj.content}}</p>
						  <div class="cmImg" >
							<img v-for="(item,index6) in obj.images" :src='item' :key="index6" alt="" @click="imageShow(obj,i)" >
						</div>
					  </div>
				  </div>
				  <van-image-preview v-model="showImgP" :images="scaleImg.images" :startPosition='startPosi'  @change="onChange">
					<template v-slot:cover>
						<div class="slotComment" >
							<p>{{scaleImg.content}}</p>
						</div>	
					</template>
				</van-image-preview>
			  </div>
			  <div class="evaluateContent" v-else>
				  <img class="noCommentImg" src="../../assets/img/default/noComment.png" alt="">
				  <p class="noCommentText" >暂无评价</p>
			  </div>
			  
		   </div>
	   </van-tab>
	   <van-tab title="推荐">
		  <div class="recommendBox" >
			  <div class="recommendTitle" >
				 <img src="../../assets/img/icon/leftEllipsis.png" alt=""> 
				 <span>为你推荐</span>
				 <img src="../../assets/img/icon/rightEllipsis.png" alt="">
			  </div>
			  <div class="recommendContent" >
				  <div class="recommendList" v-for="(item,i) in goodsInfoData.tj_goods" :key="i" >
					  <img :src='item.original' @click="goCommendGoods(item.goods_id)" alt="">
					  <div class="recommendInfo" >
						  <h4>{{item.goods_name}}</h4>
						  <p class="clearfix" >
							 <span class="price" >
								 <i>¥</i>{{item.price}}
							 </span> 
							 <!-- <span class="reclear" >
								重消{{item.point}}
							 </span> -->
						  </p>
						  
					  </div>
				  </div>
				 
			  </div>
		  </div>
	   </van-tab>
	   <van-tab title="详情">
		   <div class="detailInfo" >
			   <div class="infoTitle" >
				   <img src="../../assets/img/icon/detailTitleSide.png" alt="">
				   <span>详情</span>
				   <img src="../../assets/img/icon/detailTitleSideR.png" alt="">
			   </div>
			   <div class="infoContent" >
				   <!-- <div class="infoText" >
					   <p>
						   <span>商品名称:</span>
						   2019秋冬款黑色百搭长袖T恤弹力修身显瘦白色 半高领打底衫上衣女
					   </p>
					   <p>
					   		<span>品牌:</span>
					   		 时尚V女装
					   </p>
					   <p>
					   		<span>上架时间:</span>
					   		2019-12-12
					   </p>
				   </div> -->
				   <div v-html="goodsInfoData.intro" >
				   </div>
			   </div>
		   </div>
	   </van-tab>
	 </van-tabs>
	 <div class="goodsAction" safe-area-inset-bottom >
		 <van-goods-action >
			<van-goods-action-icon :icon=shopIcon  text="店铺"   @click="onClickShop()"/> 
		   <van-goods-action-icon :icon=serviceIcon text="客服"  @click="onClickService()" />
		   <van-goods-action-icon :icon=shoppingIcon text="购物车"  @click="onClickShopping()" />
		   <van-goods-action-button type="warning"  @click="shareGoods">
			<template v-if="goodsInfoData.rake_back_amount ==null||goodsInfoData.rake_back_amount =='0.0'" >
					<span>分享</span>
			</template>
			<template v-else >
					<span>分享赠¥{{goodsInfoData.rake_back_amount}}</span>
			</template>
		   </van-goods-action-button>
		   <van-goods-action-button type="danger" text="立即购买" @click="showBase = true" />
		 </van-goods-action>
	 </div>
	 <div v-if="goodsInfoData.luck_draw_id != null"  class="luckDrawFloating" @click="goLuckDraw(goodsInfoData.luck_draw_id)" >
		 <img src="../../assets/img/default/goLottery.png" alt="">
	 </div>
 </div>
  
</template>

<script>
import Vue from 'vue'
import { ImagePreview } from 'vant';
import { Sku } from 'vant';
// import skuData  from './skuData'
import { Toast } from 'vant';
import wx from 'weixin-js-sdk'
Vue.use(Toast);
Vue.use(Sku);
Vue.use(wx);
Vue.use(ImagePreview);

export default {
  name: 'goodsDetail',
  data() {
    return {
		 current: 0,
		  active:'',
		  index: 0,
		  goodsId:this.$route.query.goods_id,
		  shopId:1,
		  goodsInfoData:{},
		  shopInfo:{},
		  tjGoods:[],
		  buynum:0,
		  showBase: false,
		  collectState:false,
		  shopIcon:require('../../assets/img/icon/shop.png'),
		  serviceIcon:require('../../assets/img/icon/Customerservice.png'),
		  shoppingIcon:require('../../assets/img/icon/icon_Shopping.png'),
		  images: [],
		  imagesOriginal:[],
		  imagesCount:"1",
		  commentLength:0,
		  skuData:[],
		  skuId:'',
		  clickSVal:'',
		  skuSKey:null,
		  skuSpeces:[],
		  skuFirst:[],
		  topAllSku:{},
		  topSku:[],
		  singleSku:[],
		  skuIds:'',
		  strSku:'',
		  skuDataIdS:[],
		  str:[],
		  startPosi:1,
		  showImgP:false,
		 commentImages: [
			     '/img/goosDetailimg.b8889047.png',
		         '/img/goosDetailimg.b8889047.png',
		  ],
		  scaleImg:{},
		  shareURL:'',
		  specesObj:''

    }
  },
  computed:{
	
	},
  mounted(){
	  window.onscroll = function() {
		  let topHeader = document.getElementById('topHeader');
		  let gdscrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
		  if(gdscrollTop == 0){
			  topHeader.style.top = 20+'px'; 
		  }else{
			 topHeader.style.top = 50+'px';
		  }
	  };

	  this.getGoodsInfo();
	  this.getSkus();
	  this.getTopSkuArr();
	  
  },
  components: {
	
  },
  methods: {
	fanhui(){
		let invitationCode = this.$route.query.invitation_code;
		console.log(invitationCode);
		if(localStorage.getItem("isCart") == 2){
			 this.$router.push({path:'/'});
		}else{
				if(invitationCode != ""){
				this.$router.push({path:'/'});
			}else{
				this.$router.go(-1)
			}
		}

	},
	// getQueryVariable(variable){
	// 	  var query = window.location.search.substring(1);
    //    var vars = query.split("&");
    //    for (var i=0;i<vars.length;i++) {
    //            var pair = vars[i].split("=");
    //            if(pair[0] == variable){return pair[1];}
    //    }
    //    return(false);
	// },
    onChange(index) {
         this.current = index;
	   },
	ChangeNum(val){
		this.buynum=val;
		console.log(this.buynum,this.skuData[2])
		if(this.buynum>this.skuData[2]){
			this.buynum = this.skuData[2]
		}
	},
	addCart(){
		let invitationCode = this.$route.query.invitation_code
		 let param = {
			 sku_id:this.skuId,
			 num:this.buynum,
			 invitation_code : invitationCode
		 }
		 if(localStorage.getItem('isLogin') == 'true'){
		   this.postRequest(`trade/carts`,param ).then(res => {
		        Toast({
		   			message: '加入购物车成功',
		   			icon: 'certificate'
		   		  });
		   	  this.postRequest(`trade/carts/sku/${this.skuId}`,{checked : 0} ).then(res => {
		   			console.log("AAAA5")
		   		})	  
		   	})
		 }else{
		localStorage.setItem("redirect_url", window.location.href);
		  this.$router.push({path:'/login'});
		 }
		
	},
	onClickBuy(){
		console.log(this.$route.query.invitation_code);
		let invitationCode = this.$route.query.invitation_code
		 localStorage.setItem("isCart", 2);
	  localStorage.setItem("sucback", 1);
	  localStorage.setItem("goodsIds", this.goodsId);
      let param = {
			 sku_id:this.skuId,
			 num:this.buynum,
			 invitation_code : invitationCode
		 }
		 if(localStorage.getItem('isLogin') == 'true'){
			 this.postRequest(`trade/carts/buy`,param ).then(res => {
			 	 console.log(res,"123456");
			 	 if(res.data.code == 0){
					 this.$router.push({path:'./ConfirmationOrder'});
			 	 }
			 	})
		 }else{
			localStorage.setItem("redirect_url", window.location.href);
		  this.$router.push({path:'/login'});
		 }
		
	},
	getGoodsInfo(){
     this.getRequest(`goods/${this.goodsId}` ).then(res => {
		 if(res.data.data.market_enable == 0 ){
			 Toast({
				duration: 0, // 持续展示 toast
				forbidClick: true,
				message: '该商品已被下架',
				});
				let second = 2;
				let timer = setInterval(() => {
				second--;
				if (second) {
					toast.message = `该商品已被下架`;
				} else {
					clearInterval(timer);
					Toast.clear();
					window.location.href="javascript:history.go(-1)";
				}
				}, 1000);
		 }
		this.goodsInfoData = res.data.data;
		this.shopInfo=res.data.data.shop_info;
		this.shopId =res.data.data.shop_info.shop_id;
		this.goodsInfoData.gallery_list.map((item) =>{
			this.images.push(item.original);
			this.imagesOriginal.push(item.original);
		})
		this.imagesCount=this.images.length;
		this.commentLength=res.data.data.comment_list.length;
		this.collectState=res.data.data.collected;
	 })
	 },
	 getSkus(){
		Toast.loading({
			message: '加载中...',
			forbidClick: true,
			overlay:true,
			duration: 0, // 持续展示 toast
		});
 		this.getRequest(`goods/${this.goodsId}/skus` ).then(res => {
			 setTimeout(() => {
				  Toast.clear();
			 }, 500);
			
			 this.allskuData = res.data.data
			this.skuSKey=res.data.data.keys;
			this.skuIds = res.data.data.sku_ids;
			this.singleSku = res.data.data.sku;
			console.log(res.data.data.sku_ids)
			if(res.data.data.speces != null){
              res.data.data.keys.forEach((key) =>{
					res.data.data.speces[key].forEach((element,index) => {
						if(index == 0){
							element.show = true;
							this.topAllSku[key]=element.specValue;
							this.topSku.push(this.topAllSku);
							this.strSku += element.specValue;
						}else{
							element.show = false;
						}
				});
			});
			}
			console.log('this.strSku',this.strSku)
			if(this.skuSKey != null && this.skuSKey != "" && this.skuSKey != 'undefined'){
				this.skuSKey.forEach((e,i) => {
				let specesObj = res.data.data.speces
				for(var key in specesObj){
					console.log(key,specesObj[key])
					if(key == e){
						this.specesObj = specesObj;
						console.log(specesObj[key])
					}
				}
			})
			}
			this.skuSpeces = res.data.data.speces;
			this.getTopSkuArr()
		 })
	 },
	 getTopSkuArr(){
		 console.log(this.skuIds)
		 if(this.skuIds != null  && this.skuIds != '' && this.skuIds != 'undefined'){
			 console.log('22222')
					Object.getOwnPropertyNames(this.skuIds).forEach((key) =>{
					let topSkuArr=Object.values(this.topSku[0])
					let topskuStr=topSkuArr.join('');
					let topskuStrs = topskuStr.split('');
					let keyStr = key.split('');
					if(key == this.strSku || keyStr.sort().toString() == topskuStrs.sort().toString() ){
						if(this.skuIds[topskuStr] == undefined){
							
							let arrStrsku  = topskuStrs.sort().join("");
							this.skuDataIdS=this.skuIds[arrStrsku];
						}else{
							this.skuDataIdS=this.skuIds[topskuStr];
						}
						};
				});
		}	
		 console.log(1223123213,this.skuDataIdS)
		if(this.skuSKey != null && this.skuSKey != "" && this.skuSKey != 'undefined'){
			 this.skuData=this.skuDataIdS;
			  this.skuId = this.skuDataIdS[0];	
		   }else{
			   console.log(this.singleSku)
			   this.skuData = this.singleSku;
			 this.skuId = this.singleSku[0];
		   }
		this.$forceUpdate();
	 },
	 chooseSku(arr,val){
		 arr.forEach(obj=>{
			 obj.show = false;
		 })
		 this.topSku.forEach((e,i) =>{
             if(val.specName == Object.keys(this.topSku[0])[i]){
			 this.topSku[0][val.specName]=val.specValue
		 }
		 })
		 val.show = true
		 this.getTopSkuArr()
	 },
	 tgCollect(){
		 let param = {
			 goods_id:this.goodsId
		 }
		 if(localStorage.getItem('isLogin') == 'true'){
		    if(this.collectState == false){
		    			 this.postRequest(`members/collection/goods`,param).then(res => {
		    				 Toast.loading({
		    				message: '收藏成功',
		    				forbidClick: true
		    				});
		    			this.collectState = true;
		    			 }) 
		    }else{
		    			 this.deleteRequest(`members/collection/goods/${this.goodsId}`).then(res => {
		    				  Toast.loading({
		    				message: '取消收藏',
		    				forbidClick: true
		    				});
		    			this.collectState = false;	
		    			 })
		    }
		 }else{
		 localStorage.setItem("redirect_url", window.location.href);
		  this.$router.push({path:'/login'});
		 }
		
	 },
	//  分享商品
	 shareGoods(){
		let that = this
		console.log(that.imagesOriginal[0])
		 let param ={
			 goods_id :this.goodsId
		 }
		this.getRequest(`goods/shareGoods`,param).then(res => {
				console.log(res.data.code);
				this.shareURL = res.data.data;
				if(res.data.code == 0){
					let params = {
						type : "WAP",
						url : res.data.data
					}
					this.getRequest(`wechat`,params).then(res => {
						console.log(res.data.appid)
						 wx.config({
							debug: false, // 调试开关
							appId: res.data.appid, // 必填，公众号的唯一标识
							timestamp:res.data.timestamp , // 必填，生成签名的时间戳
							nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
							signature: res.data.signature,// 必填，签名
							jsApiList: ["updateAppMessageShareData","updateTimelineShareData",] // 必填，需要使用的JS接口列表
						});
						})
				}
		   })
		   		wx.ready(function(){
							 wx.updateAppMessageShareData({ 
								title: '786商城', // 分享标题
								desc: that.goodsInfoData.goods_name, // 分享描述
								link: that.shareURL, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
								imgUrl: that.imagesOriginal[0], // 分享图标
								success: function () {
								// 设置成功
								}
							});
							wx.updateTimelineShareData({ 
								title: '786商城', // 分享标题
								desc: that.goodsInfoData.goods_name, // 分享描述
								link: that.shareURL, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
								imgUrl: that.imagesOriginal[0], // 分享图标
								success: function () {
								// 设置成功
								}
							});
							Toast('请点击右上角手动分享');
						})
	},
	//  推荐商品
	 goCommendGoods(commendGoodsId){
		//  this.goodsId = commendGoodsId;
		//   this.getGoodsInfo();
	  	// this.getSkus();
		 this.$router.push({
			path:'/goodsDetail',
			query : {
				goods_id : commendGoodsId
			}
		});	
		location.reload();
	
	 },
	//  getImgUrl(imgstr){
	// 		  let imgstrs =String(imgstr);
	// 		  console.log(imgstrs)
	// 		  return imgstrs.replace(/http/, "https");
	// 	  },
	 Preview_img(images, index) {
	        ImagePreview({
	        images: images,//图片数组
	        showIndex: true,
	        loop: false,
	        startPosition: index
	                 })
	   },
    goLuckDraw(luckDrawId){
		this.$router.push({
			path:'./LuckDraw',
			query : {
				luckid : luckDrawId,
				goods_id : this.goodsId
			}
		})
	},
	onClickShop(){
		this.$router.push('./shopIndex')
	},
	onClickService(){
		// this.$router.push('./customerService')
		window.location.href= `tel:${this.shopInfo.link_phone}`;
	},
	onClickShopping(){
		 localStorage.setItem("isCart", true);
		this.$router.push('./shoppingCart')
	},
	
	allGoods(){
		this.$router.push({path:'./goodsList',query: {shop_id:this.shopId}}) 
		
	},
	goshop(){
		this.$router.push({path:'./shopIndex',query: {shop_id:this.shopId}}) 
	},
	goMoreEvaluate(){
		this.$router.push({path:'./commentDetail',query: {goods_id:this.goodsId}}) 
	},
	imageShow(obj,i){
	   this.startPosi = i;
	   this.showImgP = true;
	   this.scaleImg = obj;
	},
	
  }
}
</script>
<style scoped lang='less'>
	.goodsDetail{
		text-align: left;
		.clearfix{
			zoom: 1;
			&::after{
				content: "\20";
				height: 0;
				display: block;
				clear: both;
			}
		}
		.topHeader{
			position: fixed;
			background-color: transparent;
			top: 100px;
			z-index: 99;
			width: 100%;
			.headerLeft{
				float: left;
				margin-left: 30px;
			}
			.headerRight{
				float: right;
				margin-right: 30px;
			}
			img{
				width: 58px;
				height: 58px;
			}
		}
		/deep/ .van-tabs__wrap{
			height: 80px;
			.van-tab--active{
				position: relative;
				&::after{
					content: "";
					position: absolute;
					width: 47px;
					height: 5px;
					background:linear-gradient(to right,#F00F00,#FF9176,#FFDDD4);
					left: 75px;
					bottom:10px;
					border-radius: 8px;
				}
			}
		 .van-tabs__line{
				width: 0;
				background-color:transparent;
			}
		}
		/deep/ .van-tabs__content{
			margin-top: -80px;
			.goodsInfo{
			  .swipeBox{
					width: 100%;
					height: 889px;
				.van-swipe{
					height: 100%;
				 .van-swipe-item {
					background: url(../../assets/img/default/product.png);
					font-size: 20px;
					height: 100%;
					text-align: center;
					img{
						height: 100%;
					}
				  }
				  .custom-indicator {
					position: absolute;
					right: 5px;
					bottom: 5px;
					padding: 2px 5px;
					font-size: 12px;
					background:rgba(0,0,0,1);
					color: #fff;
					opacity:0.4;
					width: 72px;
					height: 40px;
					line-height: 40px;
					border-radius:24px;
					text-align: center;
					}
				  }
				}
			 .goodsintr{
				 text-align: left;
				 padding: 18px 40px;
				 background-color: #fff;
				 h4{
					font-size: 54px;
					 color: #FF1919;
					 font-weight: bold;
					span{
						 font-size: 40px;
					 }
				 }
				 p{
					font-size:32px; 
					color: #333333;
					margin: 10px 0;
					line-height: 42px;
					font-weight: 500;
				 }
				 .intrNum{
					 display: flex;
					 justify-content: space-between;
					 margin-top: 20px;
					 span{
						 color: #999999;
						 font-size: 24px;
					 }
					 .freight{
						img{
							width: 32px;
							height: 24px;
							display: inline-block;
							margin-right:10px;
							vertical-align: middle;
						} 
					 }
					 .SalesVolume{
					 	img{
					 		width:23px;
					 		height: 27px;
							display: inline-block;
							margin-right:10px;
							vertical-align: middle;
					 		} 
					 }
					 .BrowseVolume{
					 		img{
					 		width: 30px;
					 		height: 26px;
							display: inline-block;
							margin-right:10px;
							vertical-align: middle;
					 		} 
					 }
					 
				 }
				 
				 }
				.chooseSku{
					padding:26px 38px;
					background-color: #fff;
					margin-top:20px;
					span{
						color: #999999;
						font-size: 26px;
					}
					img{
						width: 12px;
						height: 20px;
						float: right;
						margin-top: 11px;
						margin-right: 20px;
					}
				}
				.sku-container{
					.skuBox{
						background-color: #fff;
						.skuTop{
							padding:30px;
							display: flex;
							justify-content: flex-start;
							.imgBox{
								width: 182px;
								height: 182px;
								img{
									width: 100%;
									height: 100%;
								}
							}
							.skuTopText{
								padding-top: 80px;
								margin-left: 30px;
								h4{
								  color: #FF1919;
								  font-size: 46px;
								  span{
									  font-size: 36px;
								  }
								}
								p{
									font-size: 22px;
									color: #8D8D8D;
								}
							}
						}
						  	.brand {
								padding: 20px;
								background-color: #fff;
								h4 {
									color: #040404;
									font-size: 24px;
									margin-bottom: 26px;
								}
								.brandList {
									span {
										display: inline-block;
										background: rgba(242, 242, 242, 1);
										border-radius: 27px;
										// width: 167px;
										height: 54px;
										text-align: center;
										line-height: 54px;
										margin-right: 14px;
										margin-bottom: 30px;
										overflow: hidden;
										padding:0px 15px;
										text-overflow: ellipsis;
										white-space: nowrap;
									}
						
									span:nth-child(4n) {
										margin-right: 0;
									}
									span.active {
										border: solid 2px #F33925;
										color: #FE5E15;
										background-color: #FFF8F5;
									}
								}
							}
							.dayLuckDraw {
								padding: 20px;
								background-color: #fff;
								h4 {
									color: #040404;
									font-size: 24px;
									margin-bottom: 26px;
								}
								.LuckDraw{
									span {
										display: inline-block;
										background: rgba(242, 242, 242, 1);
										border-radius: 27px;
										width: 167px;
										height: 54px;
										text-align: center;
										line-height: 54px;
										margin-right: 14px;
										margin-bottom: 30px;
									}
									span.active {
										border: solid 2px #F33925;
										color: #FE5E15;
										background-color: #FFF8F5;
									}
								}
							}
							.stepNum{
								padding: 20px;
								background-color: #fff;
								border-bottom: solid 4px #F2F2F2;
								display: flex;
								justify-content: space-between;
								h4 {
									color: #040404;
									font-size: 24px;
									margin-top: 10px;
								}
								
							}
							.filterBtn{
								padding: 40px 68px;
								display:flex;
								.joinCart{
									width:294px;
									height:67px;
									background: linear-gradient(to right,#FFB630,#FE7B01);
									border-radius:34px;
									color: #fff;
									font-size: 24px;
									margin-right: 26px;
								}
								.nowBuy{
									width:294px;
									height:67px;
									background: linear-gradient(to right,#F2170C,#F24C0B);
									color: #fff;
									font-size: 24px;
									border-radius:34px;
									
								}
							}
					}
				}
			   .shopInfo{
				   .listBox {
				   	padding: 20px 18px;
				   	.listInfo {
				   		background-color: #fff;
				   		padding: 20px 30px;
				   		.leftImg {
				   			float: left;
				   			width: 20%;
				   			img {
				   				width: 104px;
								   height: 104px;
								   object-fit: cover;
				   			}
				   		}
				   		.rightText {
				   			float: right;
				   			width: 78%;
				   			text-align: left;
				   			h5 {
				   				font-size: 28px;
				   				font-weight: 600;
				   
				   				img {
				   					display: inline-block;
				   					width: 66px;
				   					height: 30px;
									   vertical-align: middle;
									   margin-top: -6px;
				   				}
				   			}
				   			.address {
				   				font-size: 26px;
				   				color: #333;
				   				margin: 10px 0 18px 0;
				   			}
				   			.shopScore {
				   				display: flex;
				   				justify-content: space-between;
				   				width: 100%;
				   				.scoreKind {
				   					img {
				   						width: 26px;
				   						height: 26px;
				   						display: inline-block;
				   						vertical-align: middle;
				   						margin-right: 9px;
				   					}
				   
				   					span {
				   						font-size: 24px;
				   						color: #9A9A9A;
				   					}
				   
				   					p {
				   						font-size: 24px;
				   						color: #000000;
				   						text-align: center;
				   						margin-top: 10px;
				   						font-weight: 600;
				   					}
				   				}
				   			}
				   		}
				   		.shopBtn {
							text-align: center;
				   			.goodsBtn,
				   			.goshopBtn {
				   				border-radius: 25px;
				   				width: 130px;
				   				height: 50px;
				   				text-align: center;
				   				line-height: 50px;
				   				padding: 0;
				   				font-size: 22px;
				   				margin: 20px 40px;
				   			}
				   		}
				   	}
				   
				   }
			   }	 
		  }
	        .evaluateBox{
				background-color: #fff;
			 .evaluateTitle{
				 padding:23px 26px 23px 36px;
				 border-bottom: solid 1px #F5F5F5;
			 	.titleText{
					color: #333333;
					font-size: 30px;
					position: relative;
					&:after{
						content: "";
						position: absolute;
						width: 5px;
						height: 26px;
						left: -10px;
						top: 2px;
						background: linear-gradient(to bottom,#F00F00,#FF9176,#FFDDD4);
						border-radius:8px;
						}
				}
				.moreEvaluate{
					float: right;
					span{
						color: #FF5507;
						font-size: 26px;
						margin-right:15px;
					}
					img{
						width: 12px;
						height: 20px;
						display: inline-block;
					}
				}
			 }
			 .evaluateContent{
				 padding: 20px 40px;
				 margin-bottom: 20px;
				 .noCommentImg{
					 width: 200px;
					 height: 138px;
					 margin:0px auto;
					 margin-top: 30px;
				 }
				 .noCommentText{
					 color: #CCCCCC;
					 font-size: 26px;
					 text-align: center;
				 }
				 .eContentList{
					padding: 10px 0;
					margin: 20px 0;
					.eListTop{
						img{
							display: inline-block;
							width: 40px;
							height: 40px;
							margin-right:16px;
							border-radius: 50%;
						}
						span{
							color: #999999;
							font-size: 26px;
							vertical-align: super;
						}
					}
					.eListBottom{
						color: #333333;
						font-size: 26px;
						line-height:37px;
						font-weight: 400;
						.cmImg{
						display: flex;
						flex-wrap: wrap;
						margin-top: 20px;
						img{
							width: 194px;
							height: 194px;
							margin-right:8px;
							margin-bottom: 8px;
						}
						img:nth-child(3n){
							margin-right: 0;
						}
					}
					}
				 }
				 /deep/ .van-image-preview__cover{
					width: 100%;
					top: initial;
					.slotComment{
						position: absolute;
						bottom: 0;
						padding: 30px;
						p{
							color: #fff;
							font-size: 26px;
						}
					}
				}
			 }	 
			}
			.recommendBox{
				background-color: #fff;
				padding: 21px 0 21px 39px;
				.recommendTitle{
					text-align: center;
					margin: 20px 0;
					span{
						color: #000000;
						font-size: 30px;
						font-weight:500;
						margin: 0 20px;
					}
					img{
						width: 28px;
						height: 8px;
						display: inline-block;
						margin-bottom: 6px;
						}
				}
				.recommendContent{
					width: 100%;
					white-space: nowrap;
					overflow: scroll;
					.recommendList{
						display: inline-block;
						margin-right: 25px;
						img{
							width: 211px;
							height: 226px;
						}
						.recommendInfo{
							h4{
								color: #262626;
								font-size: 26px;
								font-weight:500;
								margin:22px 0;
								width:211px;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
							}
							p{
								.price{
									font-size: 30px;
									color: #FF1919;
									font-weight: bold;
									i{
										font-size: 22px;
										color:#FF1919;
										font-style: normal;
									}
								}
								.reclear{
									color: #999999;
									font-size: 24px;
									float: right;
									margin-top: 5px;
								}
							}
							
						}
					}
				}
				.recommendContent::-webkit-scrollbar {display:none}
			}
	        .detailInfo{
				.infoTitle{
					text-align: center;
					margin: 30px 0;
					span{
						color: #999999;
						font-size: 30px;
						font-weight:500;
						margin: 0 20px;
					}
					img{
						width: 129px;
						height: 5px;
						display: inline-block;
						margin-bottom: 6px;
						}
				}
				.infoContent{
					padding-bottom: 50px;
					.infoText{
						padding: 23px 39px;
						background-color: #fff;
						p{
							color: #333333;
							font-size: 26px;
							line-height:50px;
						span{
							text-align: left;
							color: #999999;
							font-size: 26px;
							}
						}
					}
					img{
						width: 100%;
						height:auto;
					}
				}
			}
	  }
	  .goodsAction{
		  background-color: rgb(255,255,255);
		  padding-bottom: 100px;
	  }
	  .luckDrawFloating{
		  position: fixed;
		  right: 10px;
		  top: 50%;
		  img{
			  width: 139px;
			  height: 150px;
		  }
	  }
	}
	
</style>

